import { useAuthStore } from "@/features/auth/useAuthStore";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const auth = useAuthStore();

  const { USETIFUL_KEY } = config.public;

  if (!USETIFUL_KEY) {
    return;
  }

  // set Usetiful tags
  window.usetifulTags = {
    ...(window.usetifulTags || {}),
    "user-roles": auth.userRoles.join(","),
  };

  // Add Usetiful script
  useHead({
    script: [
      {
        src: `https://www.usetiful.com/dist/usetiful.js`,
        id: "usetifulScript",
        async: true,
        "data-token": USETIFUL_KEY,
      },
    ],
  });
});
